import {loadJs} from './Util'

export default {
  componentCache: {},
  requestCache: {},

  getComponent ({type, version}) {
    const C_KEY = `${type}@${version}/index`
    return this.componentCache[C_KEY]
  },

  async load ({type, path, version}) {
    version = version || '0.1.0'

    const C_KEY = `${type}@${version}/index`
    const C_KEY_OLD = `${type}@${version}`

    let component = this.getComponent({type, version})

    if (component) {
      return component
    }

    let request, url

    if (!this.requestCache[C_KEY]) {
      url = path
      if (process.env.CODE_ENV !== 'production') {
        url += '?' + new Date().getTime()
      }
      this.requestCache[C_KEY] = request = loadJs(location.protocol === 'https:' ? url.replace(/^http:/, 'https:') : url)
    }
    else {
      request = this.requestCache[C_KEY]
    }

    return await request.then(() => {
      component = window[C_KEY] || window[C_KEY_OLD] || window[`${C_KEY_OLD}index`]
      this.componentCache[C_KEY] = component = component.default || component
      return component
    }).catch(e => {
      console.log('加载脚本失败', url)
      console.error(e)
    })
  },

  async loadEditor ({type, path, version}) {
    if (!path) {
      return
    }

    version = version || '0.1.0'

    const C_KEY = `${type}@${version}/editor`
    const C_KEY_OLD = `${type}@${version}editor`

    let component = this.componentCache[C_KEY]

    if (component) {
      return component
    }

    let request, url

    if (!this.requestCache[C_KEY]) {
      url = path.replace('index.js', 'editor.js')
      if (process.env.CODE_ENV !== 'production') {
        url += '?' + new Date().getTime()
      }
      this.requestCache[C_KEY] = request = loadJs(location.protocol === 'https:' ? url.replace(/^http:/, 'https:') : url)
    }
    else {
      request = this.requestCache[C_KEY]
    }

    return await request.then(() => {
      component = window[C_KEY] || window[C_KEY_OLD]
      this.componentCache[C_KEY] = component = component.default || component
      return component
    }).catch(e => {
      console.log('该组件不存在对应编辑器', type)
      console.error(e)
    })
  }
}
